import { SplitColumnsContainer } from "@startlibs/components";
import { Combobox, DatePicker, RadioboxGroup, SimpleRadiobox, TextInput } from "@startlibs/form";
import { ComboboxContainer } from "../../request/forms/ContactDetails";
import React from "react";
import styled from "styled-components";
import { getColor } from "@startlibs/utils";
import { IfLocale } from "../../hocs/IfLocale";
import { EMAIL, PHONE } from "../../enums/ContactCommunicationType";
import { AFTERNOON, EVENING, MORNING } from "../../enums/ContactTime";
import { StyledTelInputView } from "../../components/StyledTelInputView";
import { MEDICARE, OTHER, PRIVATE } from "../../enums/InsuranceType";
import { LOCAL_PHYSICIAN, REF_PHYSICIAN } from "../../enums/ContactRelationType";
import { STEP_CASE_RECONCILIATION, STEP_CASE_SETTINGS } from "../../request/forms/utils";
import { defaultDateFormat } from "../../utils/dateFormat";
import { EmergencyDisclaimer } from "../../patient/PatientCreateRequestNew";

const FieldsWrapper = styled.div`
  border: 1px solid ${getColor('gray210')};
  border-radius: 6px;
  margin: 1rem 0;
  padding: 2rem;
`;
export const PATIENT_IDENTIFICATION = 'PATIENT_IDENTIFICATION';
export const CONTACT_PARTY = 'CONTACT_PARTY';
export const PHYSICIAN = 'PHYSICIAN';
export const INSURANCE_INFORMATION = 'INSURANCE_INFORMATION';
export const PRIMARY_CONCERN = 'PRIMARY_CONCERN';
export const isOriginalForm = (type) => (type === PATIENT_IDENTIFICATION || type === CONTACT_PARTY || type === PHYSICIAN || type === INSURANCE_INFORMATION || type === PRIMARY_CONCERN)

export const getTranslatedTitles = (item, intl) => {
  switch(item) {
    case PATIENT_IDENTIFICATION:
      return intl.formatMessage({
        defaultMessage: 'Patient identification',
        description: 'Patient Identification title'
      })
    case CONTACT_PARTY:
      return intl.formatMessage({
        defaultMessage: 'Contact party',
        description: 'Contact Party title'
      })
    case PHYSICIAN:
      return intl.formatMessage({
        defaultMessage: 'Physician',
        description: 'Physician title'
      })
    case INSURANCE_INFORMATION:
      return intl.formatMessage({
        defaultMessage: 'Insurance information',
        description: 'Insurance Information title'
      })
    case PRIMARY_CONCERN:
      return intl.formatMessage({
        defaultMessage: 'Primary concern',
        description: 'Patient CaseInfo primary concern title'
      })
    
    case STEP_CASE_RECONCILIATION:
      return intl.formatMessage({
        defaultMessage: 'Case reconciliation',
        description: 'Case reconciliation title'
      })

    case STEP_CASE_SETTINGS:
      return intl.formatMessage({
        defaultMessage: 'Case settings',
        description: 'Case settings title'
      })
      
    default:
      return ''
  }
}

export const getTranslatedDescription = (item, intl) => {
  switch(item) {
    case PATIENT_IDENTIFICATION:
      return ""
    case CONTACT_PARTY:
      return intl.formatMessage({
        description: 'ContactDetails subtitle',
        defaultMessage: "This is the party responsible for this case. They may be contacted about patient information, medical records, payment, and the case report as applicable."
      })
    case PHYSICIAN:
      return intl.formatMessage({
        defaultMessage: 'Can be requested to take action on this case and may receive a copy of any resulting results.',
        description: 'Physician intake description'
      })
    case INSURANCE_INFORMATION:
      return intl.formatMessage({
        defaultMessage: 'In most cases, this service will not be covered by insurance. Only complete this section if you have been advised to by your care coordinator. This information will only be used should there be any covered procedure.',
        description: 'Insurance Information intake description'
      })
    case PRIMARY_CONCERN:
      return ''
      
    default:
      return ''
  }
}

export const TEXT = 'TEXT';
export const TEXT_AREA = 'TEXT_AREA';
export const DATE = 'DATE';
export const SELECT = 'SELECT';
export const CUSTOM_FIELDS_TYPES = [TEXT, TEXT_AREA, DATE, SELECT];

export const getTypeLabelFromType = (type) => {
  switch (type) {
    case TEXT:
      return 'Short answer field';
    case TEXT_AREA:
      return 'Paragraph field';
    case DATE:
      return 'Date field';
    case SELECT:
      return 'Dropdown field';
  }
}

export const getIconFromType = (type) => {
  switch (type) {
    case TEXT:
      return 'textinput';
    case TEXT_AREA:
      return 'textarea';
    case DATE:
      return 'calendar';
    case SELECT:
      return 'dropdown';
  }
}

const VIEWPORT_MIN_WIDTH = 500;

export const originalFormStructure = (type,intl, emergencyDisclaimer = false, isMultiLanguage = false) => {
  
  switch (type) {
    case PATIENT_IDENTIFICATION:
      return <FieldsWrapper>
        {emergencyDisclaimer && <EmergencyDisclaimer>
          {emergencyDisclaimer}
        </EmergencyDisclaimer>}
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "First name", description: "PatientDetails firstName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: John", description: "PatientDetails firstName placeholder" })}
          mandatory
        />
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Middle name", description: "PatientDetails middleName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: James", description: "PatientDetails middleName placeholder" })}
        />
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Last name", description: "PatientDetails lastName label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: Doe", description: "PatientDetails lastName placeholder" })}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <DatePicker
          raw
          disabled
          weekStartsMonday
          label={intl.formatMessage({ defaultMessage: "Date of birth", description: "Date of birth label" })}
          placeholder={intl.formatMessage({
            defaultMessage:`Ex: {dateFormat}`,
            description:"Patient login, date of birth placeholder"
          },{dateFormat:defaultDateFormat(intl).toUpperCase()})}
          format={defaultDateFormat(intl)}
          mandatory
        />
        <ComboboxContainer readOnly>
          <Combobox
            raw
            disabled
            className="combobox"
            label={intl.formatMessage({ defaultMessage: "Gender", description: "PatientDetails gender label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Please select", description: "PatientDetails gender placeholder" })}
            options={[]}
            mandatory
          />
        </ComboboxContainer>
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
          <ComboboxContainer readOnly>
            <Combobox
              raw
              disabled
              className="combobox"
              label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
              placeholder={intl.formatMessage({ defaultMessage: "Please select country", description: "PatientDetails country select placeholder" })}
              options={[]}
              mandatory
            />
          </ComboboxContainer>
          <ComboboxContainer readOnly>
            <Combobox
              raw
              disabled
              className="combobox"
              label={intl.formatMessage({ defaultMessage: "State/Province", description: "PatientDetails state label" })}
              placeholder={intl.formatMessage({ defaultMessage: "Please select state", description: "PatientDetails state select placeholder" })}
              mandatory
              options={[]}
            />
          </ComboboxContainer>
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "City", description: "PatientDetails city label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails city placeholder" })}
          maxLength={255}
          mandatory
        />
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Postal code", description: "PatientDetails postal code label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 12345", description: "PatientDetails postal code placeholder" })}
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 1", description: "PatientDetails street address line 1 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 001 Street Name", description: "PatientDetails street address line 1 placeholder" })}
          maxLength={255}
          mandatory
        />
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 2", description: "PatientDetails street address line 2 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: PO BOX 001", description: "PatientDetails street address line 2 placeholder" })}
          maxLength={255}
        />
      </SplitColumnsContainer>
    </FieldsWrapper>;

    case CONTACT_PARTY:
      return <FieldsWrapper>
        <IfLocale not contains="LEGAL">
        <ComboboxContainer readOnly style={{pointerEvents: 'none'}}>
          <Combobox
            raw
            disabled
            className="combobox"
            label={intl.formatMessage({ defaultMessage: "Select relationship to the patient", description: "ContactDetails contactRelationType label" })}
            options={[]}
            mandatory
          />
        </ComboboxContainer>
      </IfLocale>

      <IfLocale contains="LEGAL">
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
          <ComboboxContainer readOnly>
            <Combobox
              raw
              disabled
              className="combobox"
              label={intl.formatMessage({ defaultMessage: "Select relationship to the patient", description: "ContactDetails contactRelationType label" })}
              options={[]}
              mandatory
            />
          </ComboboxContainer>
        </SplitColumnsContainer>
      </IfLocale>

      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Email address", description: "ContactDetails email label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: your@email.com", description: "ContactDetails email placeholder" })}
          maxLength={255}
          mandatory
        />

        <TextInput
          raw
          disabled
          type="text"
          label={intl.formatMessage({ defaultMessage: "Confirm email", description: "ContactDetails confirm email label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: your@email.com", description: "ContactDetails confirm email placeholder" })}
          maxLength={255}
          mandatory
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <StyledTelInputView
          mandatory 
          raw
          hasErrors={false}
          label={intl.formatMessage({ defaultMessage: "Phone number", description: "ContactDetails phone number label" })}
          placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails phone number placeholder" })}
          disabled
          initOptions={{
            initialCountry: "us",
            separateDialCode: false,
            autoPlaceholder: "aggressive",
            formatOnDisplay: true,
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
            nationalMode: false,
            countryOrder: ["us"],
            validationNumberType: "FIXED_LINE_OR_MOBILE"
          }}
          tabIndex={1}
          isValid={true}
          setIsValid={() => true}
        />
        <RadioboxGroup 
          disabled 
          mandatory 
          label={intl.formatMessage({ defaultMessage: "Preferred mode of communication", description: "ContactDetails prefCommunicationMode label" })}
          horizontal 
          raw 
          framedBoxes 
          wide
        >
          <SimpleRadiobox fieldValue={PHONE} label={intl.formatMessage({ defaultMessage: "Phone", description: "ContactDetails prefCommunicationMode phone label" })} />
          <SimpleRadiobox fieldValue={EMAIL} label={intl.formatMessage({ defaultMessage: "Email", description: "ContactDetails prefCommunicationMode email label" })}  />
        </RadioboxGroup>
      </SplitColumnsContainer> 
      <RadioboxGroup disabled label="Preferred contact time" horizontal raw framedBoxes wide>
        <SimpleRadiobox fieldValue={MORNING}   label={intl.formatMessage({ defaultMessage: "Morning", description: "ContactDetails prefContactTime morning label" })} />
        <SimpleRadiobox fieldValue={AFTERNOON} label={intl.formatMessage({ defaultMessage: "Afternoon", description: "ContactDetails prefContactTime afternoon label" })} />
        <SimpleRadiobox fieldValue={EVENING}   label={intl.formatMessage({ defaultMessage: "Evening", description: "ContactDetails prefContactTime evening label" })} />
      </RadioboxGroup>
      {isMultiLanguage && <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big" style={{pointerEvents: 'none'}}>
        <ComboboxContainer readOnly style={{pointerEvents: 'none'}}>
          <Combobox
            raw
            disabled
            className="combobox"
            label={intl.formatMessage({ defaultMessage: "Preferred language", description: "ContactDetails preferred language label" })}
            options={[]}
            mandatory
          />
        </ComboboxContainer>
      </SplitColumnsContainer>}
    </FieldsWrapper>

      case PRIMARY_CONCERN:
      return <FieldsWrapper style={{pointerEvents: 'none'}}>
        <IfLocale not contains="LEGAL">
          <TextInput
            raw
            disabled
            label={intl.formatMessage({defaultMessage:"Please provide the primary diagnosis", description:"Primary concern intakeDiagnosis title"})}
            helpText={intl.formatMessage({defaultMessage:"(If unknown, please list unknown)", description:"Primary concern intakeDiagnosis help text"})}
            placeholder={intl.formatMessage({defaultMessage:"Ex. Rheumatoid Arthritis", description:"Primary concern intakeDiagnosis placeholder"})}
            mandatory
          />
        </IfLocale>
        <IfLocale not contains="LEGAL">
          <RadioboxGroup
            disabled
            raw
            mandatory
            label={intl.formatMessage({defaultMessage:"Has the patient been treated or had surgery for this condition before?", description:"Primary hasBeenTreatedOrSurgeryBefore concern title"})}
            horizontal
            framedBoxes
            wide
          >
            <SimpleRadiobox fieldValue={true} label={intl.formatMessage({defaultMessage:"Yes", description:"Yes"})} />
            <SimpleRadiobox fieldValue={false} label={intl.formatMessage({defaultMessage:"No", description:"No"})} /> 
          </RadioboxGroup>
          <TextInput
            disabled
            textarea
            autoResize
            raw
            label={intl.formatMessage({defaultMessage:"If so, please describe", description:"Primary concern hasBeenTreatedOrSurgeryBefore description"})}
            placeholder={intl.formatMessage({defaultMessage:"Provide any relevant details here", description:"Primary concern hasBeenTreatedOrSurgeryBefore placeholder"})}
          />
        </IfLocale>
        <TextInput
          raw
          disabled
          textarea
          autoResize
          label={intl.formatMessage({
            defaultMessage:"Please add a description of your request including a brief medical history, current treatment plan, specific questions you may have, and any other pertinent information.",
            description:"Patient CaseInfo clinical summary details label"
          })}
          mandatory
        />
      </FieldsWrapper>

      case INSURANCE_INFORMATION:
      return <FieldsWrapper style={{pointerEvents: 'none'}}>
        <RadioboxGroup
          disabled
          raw
          mandatory
          label={intl.formatMessage({defaultMessage:"Insurance type", description:"Insurance type label"})}
          horizontal
          framedBoxes
          wide
        >
          <SimpleRadiobox fieldValue={MEDICARE} label={intl.formatMessage({defaultMessage:"Medicare", description:"Insurance type: Medicare"})}/>
          <SimpleRadiobox fieldValue={PRIVATE} label={intl.formatMessage({defaultMessage:"Private insurance", description:"Insurance type: Private insurance"})}/>
          <SimpleRadiobox fieldValue={OTHER} label={intl.formatMessage({defaultMessage:"Other", description:"Insurance type: Other"})}/>
        </RadioboxGroup>
        <TextInput
          raw
          disabled
          label={intl.formatMessage({defaultMessage:"Medicare code / Other insurance information", description:"Insurance information label"})}
          mandatory
        />
      </FieldsWrapper>

      case PHYSICIAN:
      return <FieldsWrapper style={{pointerEvents: 'none'}}>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "First name", description: "Physician step first name" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: John", description: "Physician step first name" })}
            maxLength={255}
          />
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Last name", description: "Physician step last name" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: Doe", description: "Physician step last name" })}
            maxLength={255}
          />
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <RadioboxGroup 
            disabled
            label={intl.formatMessage({ defaultMessage: "Physician role", description: "Physician role" })}
            horizontal 
            raw
            framedBoxes 
            wide
          >
            <SimpleRadiobox fieldValue={REF_PHYSICIAN}   label={intl.formatMessage({ defaultMessage: "Referring", description: "Physician role Referring" })} disabled={true}/>
            <SimpleRadiobox fieldValue={LOCAL_PHYSICIAN} label={intl.formatMessage({ defaultMessage: "Local", description: "Physician role Local" })} disabled={true} />
          </RadioboxGroup>
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Institution", description: "Physician step institution" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: Purview", description: "Physician step institution" })}
            maxLength={255}
          />
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <ComboboxContainer readOnly>
            <Combobox
              raw
              disabled
              className="combobox"
              label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
              placeholder={intl.formatMessage({ defaultMessage: "Please select country", description: "PatientDetails country select placeholder" })}
              options={[]}
            />
          </ComboboxContainer>
          <ComboboxContainer readOnly>
            <Combobox
              raw
              disabled
              className="combobox"
              label={intl.formatMessage({ defaultMessage: "State/Province", description: "PatientDetails state label" })}
              placeholder={intl.formatMessage({ defaultMessage: "Please select state", description: "PatientDetails state select placeholder" })}
              options={[]}
            />
          </ComboboxContainer>
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "City", description: "PatientDetails city label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails city placeholder" })}
            maxLength={255}
          />
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Postal code", description: "PatientDetails postal code label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: 12345", description: "PatientDetails postal code placeholder" })}
            maxLength={255}
          />
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Street address - Line 1", description: "PatientDetails street address line 1 label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: 001 Street Name", description: "PatientDetails street address line 1 placeholder" })}
            maxLength={255}
          />
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Street address - Line 2", description: "PatientDetails street address line 2 label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: PO BOX 001", description: "PatientDetails street address line 2 placeholder" })}
            maxLength={255}
          />
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Email address", description: "Physician email address label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}  
            maxLength={255}
          />
          <TextInput
            raw
            disabled
            type="text"
            label={intl.formatMessage({ defaultMessage: "Confirm email", description: "Physician confirm email address label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}
            maxLength={255}
            mandatory={false}
          />
        </SplitColumnsContainer>
        <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
          <StyledTelInputView
            hasErrors={false}
            label={intl.formatMessage({ defaultMessage: "Phone number", description: "ContactDetails phone number label" })}
            placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails phone number placeholder" })}
            disabled
            initOptions={{
              initialCountry: "us",
              separateDialCode: false,
              autoPlaceholder: "aggressive",
              formatOnDisplay: true,
              placeholderNumberType: "FIXED_LINE_OR_MOBILE",
              nationalMode: false,
              countryOrder: ["us"],
              validationNumberType: "FIXED_LINE_OR_MOBILE"
            }}
            tabIndex={1}
            isValid={true}
            setIsValid={() => true}
          />
          <StyledTelInputView
            hasErrors={false}
            label={intl.formatMessage({ defaultMessage: "Fax number", description: "ContactDetails fax number label" })}
            placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails fax number placeholder" })}
            disabled
            initOptions={{
              initialCountry: "us",
              separateDialCode: false,
              autoPlaceholder: "aggressive",
              formatOnDisplay: true,
              placeholderNumberType: "FIXED_LINE_OR_MOBILE",
              nationalMode: false,
              countryOrder: ["us"],
              validationNumberType: "FIXED_LINE_OR_MOBILE"
            }}
            tabIndex={1}
            isValid={true}
            setIsValid={() => true}
          />
        </SplitColumnsContainer>
        {/* TODO: NPI and made aware of the case? */}
    </FieldsWrapper>
      
    
    default:
      return <></>
  }
}